'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.send = undefined;

require('isomorphic-fetch');

var _qs = require('qs');

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var getUrlQuery = function getUrlQuery(query) {
  if (Object.keys(query).length > 0) {
    return '?' + _qs2.default.stringify(query, { encode: false });
  }

  return '';
};

var buildUrl = function buildUrl(req) {
  var url = req.url + req.uri + getUrlQuery(req.query);
  return Object.keys(req.params).reduce(function (parsedUrl, param) {
    return parsedUrl.replace(':' + param, req.params[param]);
  }, url);
};

var send = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(req) {
    var debug, handleResponse, request, url, options, response;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            debug = req.debug, handleResponse = req.handleResponse, request = _objectWithoutProperties(req, ['debug', 'handleResponse']);
            url = buildUrl(request);
            options = {
              method: req.method,
              headers: req.headers,
              body: req.body,
              search: req.query
            };


            if (debug) {
              console.log('Performing request:');
              console.log(req);
              console.log(url);
              console.log(options);
            }

            _context.next = 6;
            return fetch(url, options);

          case 6:
            response = _context.sent;
            return _context.abrupt('return', handleResponse(response));

          case 8:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function send(_x) {
    return _ref.apply(this, arguments);
  };
}();
exports.send = send;